module.exports = __webpack_public_path__ + "img/csspw-logo.1a04d8ff.png";